import {
  ArticlesBlockFragment,
  BrandsBlockFragment,
  BulletListBlockFragment,
  DocumentLinkBlockFragment,
  EmployeeBlockFragment,
  GridContainerBlockFragment,
  GridFourColBlockFragment,
  GridThreeColBlockFragment,
  GridTwoColBlockFragment,
  HeroBlockFragment,
  ImageBlockFragment,
  JobsListBlockFragment,
  MediaWithCaptionFragment,
  NewsAndReportsListBlockFragment,
  NewsListBlockFragment,
  OfficesBlockFragment,
  PageNavigationBlockFragment,
  PlugBlockFragment,
  ReportsListBlockFragment,
  SimpleTitleAndTextBlockFragment,
  SliderBlockFragment,
  StatementBlockFragment,
  SubheadingBlockFragment,
  SustainabilityReportsBlockFragment,
  TextBlockFragment,
  TwoColumnImageAndTextBlockFragment,
  TwoColumnTextIntroBlockFragment,
  VideoBlockFragment,
} from '../dato';

export function isArticlesBlock(item: any): item is ArticlesBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'ArticlesBlockRecord';
}

export function isBulletListBlock(item: any): item is BulletListBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'BulletListRecord';
}

export function isDocumentLinkBlock(
  item: any,
): item is DocumentLinkBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'DocumentLinkBlockRecord';
}

export function isEmployeeBlock(item: any): item is EmployeeBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'EmployeeRecord';
}

export function isHeroBlock(item: any): item is HeroBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'HeroBlockRecord';
}

export function isGridContainerBlock(
  item: any,
): item is GridContainerBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'GridContainerBlockRecord';
}

export function isGridTwocolBlock(item: any): item is GridTwoColBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'GridTwocolBlockRecord';
}

export function isGridThreecolBlock(
  item: any,
): item is GridThreeColBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'GridThreecolBlockRecord';
}

export function isGridFourcolBlock(
  item: any,
): item is GridFourColBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'GridFourcolBlockRecord';
}

export function isImageBlock(item: any): item is ImageBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'ImageRecord';
}

export function isMediaWithCaptionBlock(
  item: any,
): item is MediaWithCaptionFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'MediaWithCaptionRecord';
}

export function isOfficesBlock(item: any): item is OfficesBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'OfficesBlockRecord';
}

export function isOurBrandsBlock(item: any): item is BrandsBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'BrandsBlockRecord';
}

export function isPlugBlock(item: any): item is PlugBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'PlugBlockRecord';
}

export function isSimpleTitleAndTextBlock(
  item: any,
): item is SimpleTitleAndTextBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'SimpleTitleAndTextBlockRecord';
}

export function isSliderBlock(item: any): item is SliderBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'SliderBlockRecord';
}

export function isStatementBlock(item: any): item is StatementBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'StatementBlockRecord';
}

export function isSubheadingBlock(item: any): item is SubheadingBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'SubheadingBlockRecord';
}

export function isTextBlock(item: any): item is TextBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'TextBlockRecord';
}

export function isTwoColumnTextImageBlock(
  item: any,
): item is TwoColumnImageAndTextBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'TwoColumnImageAndTextRecord';
}

export function isTwoColumnTextIntroBlock(
  item: any,
): item is TwoColumnTextIntroBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'TwoColumnTextIntroRecord';
}

export function isVideoBlock(item: any): item is VideoBlockFragment {
  if (!Object.prototype.hasOwnProperty.call(item, '__typename')) {
    return false;
  }
  return item.__typename === 'VideoRecord';
}

export function isNewsListBlock(item: any): item is NewsListBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'NewsListBlockRecord';
}
export function isNewsAndReportsListBlock(
  item: any,
): item is NewsAndReportsListBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'NewsAndReportsListBlockRecord';
}

export function isJobsListBlock(item: any): item is JobsListBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'JobsListBlockRecord';
}

export function isReportsListBlock(
  item: any,
): item is ReportsListBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'ReportsListBlockRecord';
}

export function isSustainabilityReportsBlock(
  item: any,
): item is SustainabilityReportsBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'SustainabilityReportsBlockRecord';
}

export function isPageNavigationBlock(
  item: any,
): item is PageNavigationBlockFragment {
  if (!('__typename' in item)) {
    return false;
  }
  return item.__typename === 'PageNavigationBlockRecord';
}
